import { Button } from "./styles";
import { useTheme } from "styled-components";
import Icon from "../../../Icon";
import PlayEmptyIcon from "../../../../assets/icons/icon-cool/outline/Arrows-chevron/Right.svg";

interface ComponentProps {}

const Component = ({}: ComponentProps) => {
  const theme = useTheme() as { [key: string]: { [key: string]: string } };
  return (
    <Button>
      <Icon icon={PlayEmptyIcon} size="16px" color="#e5e5e5" />
    </Button>
  );
};

export default Component;
